import Component from 'D:/小小程序员/项目/medical-management/OPO-uni/node_modules/@dcloudio/uni-ui/lib/uni-icons/uni-icons.vue'
wx.createComponent(Component)